// Dati strutturati Google (usati dall'app e dallo script di pre-rendering).
const SEO = require("./seo.json");

const absUrl = (u) => (u.startsWith("/") ? `${SEO.siteUrl}${u}` : u);

const productJsonLd = (p) => [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SEO.siteUrl}/` },
      { "@type": "ListItem", position: 2, name: "Shop", item: `${SEO.siteUrl}/shop` },
      { "@type": "ListItem", position: 3, name: p.name, item: `${SEO.siteUrl}/shop/${p.slug}` },
    ],
  },
];

module.exports = { productJsonLd, absUrl };
